export const unauthorizedCountWithLocalStorage = ({ initial, key }: { initial?: number; key: string }): number => {
  if (initial) {
    // 初期値が存在する場合は、それを設定する
    localStorage.setItem(key, initial.toString())
    return 0
  } else {
    const count = Number.parseInt(localStorage.getItem(key) || '0')
    localStorage.setItem(key, (count + 1).toString())
    return count
  }
}
